import React from 'react';
import '../template-file-css/document-file-template.css';


export const AFHS_Aims = ({
    itemsRef,
    showErrorFor,
}) => {

    return (
        <form id='AFHS_Aims' className='file-pdf-document'>
            <div className='file-template'>
                <p className='w-750'><h3>ABNORMAL INVOLUNTARY MOVEMENT SCALE (AIMS)</h3></p><br />

                <table>
                    <tr>
                        <td className='w-375'>
                            Public Health Service<br/>
                            Alcohol, Drug Abuse, and Mental Health Administration<br/>
                            National Institute of Mental Health
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Prescribing Practitioner:</span>
                            <input type='text' id='txtPrescribingPractitioner' name='txtPrescribingPractitioner' className='add-only' />
                        </td>
                    </tr>
                    
                </table>

                <p className='w-750'><b>INSTRUCTIONS:</b>Complete Examination Procedure (attachment d.)
                    before making ratings</p>

                <p className='w-750'><b>MOVEMENT RATINGS:</b>Rate highest severity observed. Rate
                    movements that occur upon activation one less than those observed
                    spontaneously. Circle movement as well as code number that
                    applies.</p>

                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>RATER</span></td>
                        <td className='w-375'>
                            <span className='eleHeader'>Date</span></td>
                    </tr>

                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtRater' name='txtRater' className='add-only' /></td>
                        <td className='w-375'>
                            <input type='date' id='txtDate' name='txtDate' className='add-only' /></td>

                    </tr>

                </table>
                <p className='w-750'><b>CODE:</b></p>
                <table>
                    <tr>
                        <td className='w-100'>0 = None</td>
                        <td className='w-250'>1 = Minimal, may be extreme normal</td>
                        <td className='w-100'>2 = Mild</td>
                        <td className='w-150'>3 = Moderate</td>
                        <td className='w-150'>4 - Severe</td>

                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-500'>
                            <span className='eleHeader'>Facial and Oral Movements</span></td>
                        <td className='w-50'>
                            <center><span className='eleHeader'>0</span></center></td>
                        <td className='w-50'>
                            <center><span className='eleHeader'>1</span></center></td>
                        <td className='w-50'>
                            <center><span className='eleHeader'>2</span></center></td>
                        <td className='w-50'>
                            <center><span className='eleHeader'>3</span></center></td>
                        <td className='w-50'>
                            <center><span className='eleHeader'>4</span></center></td>
                    </tr>
                </table>

                <table className='altRows'>
                    <tr>
                        <td className='w-500'><b>1. Muscles of Facial Expression</b><span>  e.g. movements of forehead, eyebrows
                            periorbital area, cheeks, including frowning
                            blinking, smiling, grimacing</span></td>
                        <td className='w-50'>
                            <center><input type='radio' id='rbMusclesOfFacialExpression_0' name='rbMusclesOfFacialExpression' className='add-only' value='0' />
                            </center></td>
                        <td className='w-50'>
                            <center><input type='radio' id='rbMusclesOfFacialExpression_1' name='rbMusclesOfFacialExpression' className='add-only' value='1' />
                            </center></td>
                        <td className='w-50'>
                            <center><input type='radio' id='rbMusclesOfFacialExpression_2' name='rbMusclesOfFacialExpression' className='add-only' value='2' />
                            </center></td>
                        <td className='w-50'>
                            <center><input type='radio' id='rbMusclesOfFacialExpression_3' name='rbMusclesOfFacialExpression' className='add-only' value='3' />
                            </center></td>
                        <td className='w-50'>
                            <center><input type='radio' id='rbMusclesOfFacialExpression_4' name='rbMusclesOfFacialExpression' className='add-only' value='4' />
                            </center></td>
                    </tr>

                    <tr>
                        <td className='w-500'><b>2. Lips and Perioral Area</b><span>  e.g. puckering, pouting, smacking</span></td>
                        <td className='w-50'>
                            <center><input type='radio' id='rbLipsAndPerioralArea_0' name='rbLipsAndPerioralArea' className='add-only' value='0' />
                            </center></td>
                        <td className='w-50'>
                            <center><input type='radio' id='rbLipsAndPerioralArea_1' name='rbLipsAndPerioralArea' className='add-only' value='1' />
                            </center></td>
                        <td className='w-50'>
                            <center><input type='radio' id='rbLipsAndPerioralArea_2' name='rbLipsAndPerioralArea' className='add-only' value='2' />
                            </center></td>
                        <td className='w-50'>
                            <center><input type='radio' id='rbLipsAndPerioralArea_3' name='rbLipsAndPerioralArea' className='add-only' value='3' />
                            </center></td>
                        <td className='w-50'>
                            <center><input type='radio' id='rbLipsAndPerioralArea_4' name='rbLipsAndPerioralArea' className='add-only' value='4' />
                            </center></td>
                    </tr>

                    <tr>
                        <td className='w-500'><b>3. Jaw</b><span>  e.g. biting, clenching, chewing, mouth opening, lateral movement</span></td>
                        <td className='w-50'>
                            <center><input type='radio' id='rbJaw_0' name='rbJaw' className='add-only' value='0' />
                            </center></td>
                        <td className='w-50'>
                            <center><input type='radio' id='rbJaw_1' name='rbJaw' className='add-only' value='1' />
                            </center></td>
                        <td className='w-50'>
                            <center><input type='radio' id='rbJaw_2' name='rbJaw' className='add-only' value='2' />
                            </center></td>
                        <td className='w-50'>
                            <center><input type='radio' id='rbJaw_3' name='rbJaw' className='add-only' value='3' />
                            </center></td>
                        <td className='w-50'>
                            <center><input type='radio' id='rbJaw_4' name='rbJaw' className='add-only' value='4' />
                            </center></td>
                    </tr>

                    <tr>
                        <td className='w-500'><b>4. Tongue</b><span>  Rate only increases in movement
                            both in and out of mouth. NOT inability to
                            sustain movement. Darting in and out of
                            mouth.</span></td>
                        <td className='w-50'>
                            <center><input type='radio' id='rbTongue_0' name='rbTongue' className='add-only' value='0' />
                            </center></td>
                        <td className='w-50'>
                            <center><input type='radio' id='rbTongue_1' name='rbTongue' className='add-only' value='1' />
                            </center></td>
                        <td className='w-50'>
                            <center><input type='radio' id='rbTongue_2' name='rbTongue' className='add-only' value='2' />
                            </center></td>
                        <td className='w-50'>
                            <center><input type='radio' id='rbTongue_3' name='rbTongue' className='add-only' value='3' />
                            </center></td>
                        <td className='w-50'>
                            <center><input type='radio' id='rbTongue_4' name='rbTongue' className='add-only' value='4' />
                            </center></td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-500'>
                            <span className='eleHeader'>Extremity Movements</span></td>
                        <td className='w-50'>
                            <center><span className='eleHeader'>0</span></center></td>
                        <td className='w-50'>
                            <center><span className='eleHeader'>1</span></center></td>
                        <td className='w-50'>
                            <center><span className='eleHeader'>2</span></center></td>
                        <td className='w-50'>
                            <center><span className='eleHeader'>3</span></center></td>
                        <td className='w-50'>
                            <center><span className='eleHeader'>4</span></center></td>
                    </tr>
                </table>

                <table className='altRows'>
                    <tr>
                        <td className='w-500'><b>5. Upper (arms, wrists,, hands, fingers)</b><span>  Include choreic movements (i.e., rapid, objectively purposeless, irregular, spontaneous) athetoid movements (i.e.,slow, irregular, complex, serpentine). DO NOT INCLUDE TREMOR (i.e., repetitive, regular, rhythmic)</span></td>
                        <td className='w-50'>
                            <center><input type='radio' id='rbUpperArmsWristsHandsFingers_0' name='rbUpperArmsWristsHandsFingers' className='add-only' value='0' />
                            </center></td>
                        <td className='w-50'>
                            <center><input type='radio' id='rbUpperArmsWristsHandsFingers_1' name='rbUpperArmsWristsHandsFingers' className='add-only' value='1' />
                            </center></td>
                        <td className='w-50'>
                            <center><input type='radio' id='rbUpperArmsWristsHandsFingers_2' name='rbUpperArmsWristsHandsFingers' className='add-only' value='2' />
                            </center></td>
                        <td className='w-50'>
                            <center><input type='radio' id='rbUpperArmsWristsHandsFingers_3' name='rbUpperArmsWristsHandsFingers' className='add-only' value='3' />
                            </center></td>
                        <td className='w-50'>
                            <center><input type='radio' id='rbUpperArmsWristsHandsFingers_4' name='rbUpperArmsWristsHandsFingers' className='add-only' value='4' />
                            </center></td>
                    </tr>

                    <tr>
                        <td className='w-500'><b>6. Lower (legs, knees, ankles, toes)</b><span>  e.g., lateral knee movement, foot tapping,
                            heel dropping, foot squirming, inversion and
                            eversion of foot</span></td>
                        <td className='w-50'>
                            <center><input type='radio' id='rbLowerLegsKneesAnkles_0' name='rbLowerLegsKneesAnkles' className='add-only' value='0' />
                            </center></td>
                        <td className='w-50'>
                            <center><input type='radio' id='rbLowerLegsKneesAnkles_1' name='rbLowerLegsKneesAnkles' className='add-only' value='1' />
                            </center></td>
                        <td className='w-50'>
                            <center><input type='radio' id='rbLowerLegsKneesAnkles_2' name='rbLowerLegsKneesAnkles' className='add-only' value='2' />
                            </center></td>
                        <td className='w-50'>
                            <center><input type='radio' id='rbLowerLegsKneesAnkles_3' name='rbLowerLegsKneesAnkles' className='add-only' value='3' />
                            </center></td>
                        <td className='w-50'>
                            <center><input type='radio' id='rbLowerLegsKneesAnkles_4' name='rbLowerLegsKneesAnkles' className='add-only' value='4' />
                            </center></td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-500'>
                            <span className='eleHeader'>Trunk Movements</span></td>
                        <td className='w-50'>
                            <center><span className='eleHeader'>0</span></center></td>
                        <td className='w-50'>
                            <center><span className='eleHeader'>1</span></center></td>
                        <td className='w-50'>
                            <center><span className='eleHeader'>2</span></center></td>
                        <td className='w-50'>
                            <center><span className='eleHeader'>3</span></center></td>
                        <td className='w-50'>
                            <center><span className='eleHeader'>4</span></center></td>
                    </tr>
                    <tr>
                        <td className='w-500'><b>7. Neck, shoulders, hips</b><span>   e.g.,rocking,
                            twisting, squirming, pelvic gyrations</span></td>
                        <td className='w-50'>
                            <center><input type='radio' id='rbNeckShouldersHips_0' name='rbNeckShouldersHips' className='add-only' value='0' />
                            </center></td>
                        <td className='w-50'>
                            <center><input type='radio' id='rbNeckShouldersHips_1' name='rbNeckShouldersHips' className='add-only' value='1' />
                            </center></td>
                        <td className='w-50'>
                            <center><input type='radio' id='rbNeckShouldersHips_2' name='rbNeckShouldersHips' className='add-only' value='2' />
                            </center></td>
                        <td className='w-50'>
                            <center><input type='radio' id='rbNeckShouldersHips_3' name='rbNeckShouldersHips' className='add-only' value='3' />
                            </center></td>
                        <td className='w-50'>
                            <center><input type='radio' id='rbNeckShouldersHips_4' name='rbNeckShouldersHips' className='add-only' value='4' />
                            </center></td>
                    </tr>

                </table>

                <table>
                    <tr>
                        <td className='w-500'>
                            <span className='eleHeader'>Global Judgments</span></td>
                        <td className='w-50'>
                            <center><span className='eleHeader'>0</span></center></td>
                        <td className='w-50'>
                            <center><span className='eleHeader'>1</span></center></td>
                        <td className='w-50'>
                            <center><span className='eleHeader'>2</span></center></td>
                        <td className='w-50'>
                            <center><span className='eleHeader'>3</span></center></td>
                        <td className='w-50'>
                            <center><span className='eleHeader'>4</span></center></td>
                    </tr>
                </table>
                <table className='altRows'>

                    <tr>
                        <td className='w-500'><b>8. Severity of abnormal movements overall </b></td>
                        <td className='w-50'>
                            <center><input type='radio' id='rbSeverityOfAbnormalMovements_0' name='rbSeverityOfAbnormalMovements' className='add-only' value='0' />
                            </center></td>
                        <td className='w-50'>
                            <center><input type='radio' id='rbSeverityOfAbnormalMovements_1' name='rbSeverityOfAbnormalMovements' className='add-only' value='1' />
                            </center></td>
                        <td className='w-50'>
                            <center><input type='radio' id='rbSeverityOfAbnormalMovements_2' name='rbSeverityOfAbnormalMovements' className='add-only' value='2' />
                            </center></td>
                        <td className='w-50'>
                            <center><input type='radio' id='rbSeverityOfAbnormalMovements_3' name='rbSeverityOfAbnormalMovements' className='add-only' value='3' />
                            </center></td>
                        <td className='w-50'>
                            <center><input type='radio' id='rbSeverityOfAbnormalMovements_4' name='rbSeverityOfAbnormalMovements' className='add-only' value='4' />
                            </center></td>
                    </tr>

                    <tr>
                        <td className='w-500'><b>9. Incapacitation due to abnormal movements</b></td>
                        <td className='w-50'>
                            <center><input type='radio' id='rbIncapacitionDueAbnormalMovements_0' name='rbIncapacitionDueAbnormalMovements' className='add-only' value='0' />
                            </center></td>
                        <td className='w-50'>
                            <center><input type='radio' id='rbIncapacitionDueAbnormalMovements_1' name='rbIncapacitionDueAbnormalMovements' className='add-only' value='1' />
                            </center></td>
                        <td className='w-50'>
                            <center><input type='radio' id='rbIncapacitionDueAbnormalMovements_2' name='rbIncapacitionDueAbnormalMovements' className='add-only' value='2' />
                            </center></td>
                        <td className='w-50'>
                            <center><input type='radio' id='rbIncapacitionDueAbnormalMovements_3' name='rbIncapacitionDueAbnormalMovements' className='add-only' value='3' />
                            </center></td>
                        <td className='w-50'>
                            <center><input type='radio' id='rbIncapacitionDueAbnormalMovements_4' name='rbIncapacitionDueAbnormalMovements' className='add-only' value='4' />
                            </center></td>
                    </tr>
                    <tr>
                        <td className='w-500'><b>10. Patient's awareness of abnormal movements.</b>. Rate only patient's report</td>
                        <td className='w-50'>
                            <center><input type='radio' id='rbPatientAwarenessOfAbnormal_0' name='rbPatientAwarenessOfAbnormal' className='add-only' value='0' />
                            </center></td>
                        <td className='w-50'>
                            <center><input type='radio' id='rbPatientAwarenessOfAbnormal_1' name='rbPatientAwarenessOfAbnormal' className='add-only' value='1' />
                            </center></td>
                        <td className='w-50'>
                            <center><input type='radio' id='rbPatientAwarenessOfAbnormal_2' name='rbPatientAwarenessOfAbnormal' className='add-only' value='2' />
                            </center></td>
                        <td className='w-50'>
                            <center><input type='radio' id='rbPatientAwarenessOfAbnormal_3' name='rbPatientAwarenessOfAbnormal' className='add-only' value='3' />
                            </center></td>
                        <td className='w-50'>
                            <center><input type='radio' id='rbPatientAwarenessOfAbnormal_4' name='rbPatientAwarenessOfAbnormal' className='add-only' value='4' />
                            </center></td>
                    </tr>
                </table>
                <table>
                    <ul>
                        <li className='w-750'>No awareness = 0</li>
                        <li className='w-750'>Aware, no distress  = 1</li>
                        <li className='w-750'>Aware, mild distress = 2</li>
                        <li className='w-750'>Aware, moderate distress = 3</li>
                        <li className='w-750'>Aware, severe distress = 4</li>
                    </ul>
                    </table>

                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Dental Status</span></td>
                    </tr>
                </table>
                <table className='altRows'>
                    <tr>
                        <td className='w-550'><b>11.</b>Current problems with teeth and/ordentures</td>
                        <td className='w-100'>
                            <input type='radio' id='rbCurrentProblemWithTeeth_Yes' name='rbCurrentProblemWithTeeth' className='add-only' value='Yes' /> Yes</td>
                        <td className='w-100'>
                            <input type='radio' id='rbCurrentProblemWithTeeth_No' name='rbCurrentProblemWithTeeth' className='add-only' value='No' /> No</td>
                    </tr>
                    <tr>
                        <td className='w-550'><b>12.</b> Are dentures usually worn?</td>
                        <td className='w-100'>
                            <input type='radio' id='rbAreDenturesUsuallyWorn_Yes' name='rbAreDenturesUsuallyWorn' className='add-only' value='Yes' /> Yes</td>
                        <td className='w-100'>
                            <input type='radio' id='rbAreDenturesUsuallyWorn_No' name='rbAreDenturesUsuallyWorn' className='add-only' value='No' /> No</td>
                    </tr>

                    <tr>
                        <td className='w-550'><b>13.</b>Edentia?</td>
                        <td className='w-100'>
                            <input type='radio' id='rbEdentia_Yes' name='rbEdentia' className='add-only' value='Yes' /> Yes</td>
                        <td className='w-100'>
                            <input type='radio' id='rbEdentia_No' name='rbEdentia' className='add-only' value='No' /> No</td>
                    </tr>

                    <tr>
                        <td className='w-550'><b>14.</b>Do movements disappear in sleep?</td>
                        <td className='w-100'>
                            <input type='radio' id='rbDoMovementsDisappear_Yes' name='rbDoMovementsDisappear' className='add-only' value='Yes' /> Yes</td>
                        <td className='w-100'>
                            <input type='radio' id='rbDoMovementsDisappear_No' name='rbDoMovementsDisappear' className='add-only' value='No' /> No</td>
                    </tr>

                </table>
                <p className='w-750'><span className='small'><center>This information is available in the public domain and has not been modified.</center></span></p>












            </div>
        </form >

    )
}   